export const variant1 = 'variant1';
export const variant2 = 'variant2';
export const CHARGING = 'charging';
export const WHEELS = 'wheels';
export const ACCESSORIES = 'accessories';
export const PROTECTION = 'protection';
export const EXTERIOR = 'exterior';
export const INTERIOR = 'interior';
export const paymentOptionLabelMap = {
    biweekly: 'Shared.Common.biweeklyOptionLabel',
    weekly: 'Shared.Common.weeklyOptionLabel',
    monthly: 'Shared.Common.monthlyOptionLabel',
};
export const IN_VIEW_ROOT_MARGIN = '-10% 0% 0% 0%';
export const IN_VIEW_STYLE = { scrollMarginTop: '5em' };
export const IN_VIEW_THRESHOLD = 0.1;
